import { StateDeclarations } from '../storage/state-declaration.js';
import { EventDeclarations } from '../event-store/event-declarations.js';
import { OutputDeclarations } from './output-declarations.js';
import { RealmDefinition } from '../realm/realm-definition.js';
import { AuthProviders } from '../authentication/auth-providers.js';
import { HandleDeclarations } from './handle-declarations.js';
import { StreamOptions } from './stream-options.js';
import { generateVersion } from '../realm/generate-version.js';
import { StreamHostRuntime } from '../runtime/host-runtime.js';
import { createHostRuntime } from '../runtime/create-host-runtime.js';

export function defineStream<
  TState extends StateDeclarations,
  TEvent extends EventDeclarations,
  THandle extends HandleDeclarations<TState, TEvent, TOutput>,
  TOutput extends OutputDeclarations,
  TRealm extends RealmDefinition<AuthProviders>,
>(
  realm: TRealm,
  opts: StreamOptions<TState, TEvent, THandle, TOutput>,
): StreamHostRuntime<TState, TEvent, TOutput, TRealm> {
  return {
    source: {
      realm: realm,
      version: generateVersion(opts.state, opts.events, opts.outputs, {
        stateGrant: opts.stateGrant ?? [],
        eventGrant: opts.eventGrant ?? [],
      }),
      outputs: opts.outputs,
      state: opts.state,
      events: opts.events,
      pattern: opts.pattern,
      handle: opts.handle,
      auth: opts.auth,
      stateGrant: opts.stateGrant ?? [],
      eventGrant: opts.eventGrant ?? [],
    },
    runtime: createHostRuntime(opts.events, opts.handle, opts.outputs),
  };
}
